/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import { SocialMediaShareButton } from '@pareto-engineering/design-system'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'case-study-heading'

/**
 * This is the component description.
 */
const CaseStudyHeading = ({
  id,
  className:userClassName,
  style,
  children,
  title,
  subtitle,
  initialProp,
  initialValue,
  secondaryProp,
  secondaryValue,
  mainImage,
  ...otherProps
}) => (
  <div
    id={id}
    className={[
      'span-grid grid',
      baseClassName,
      componentClassName,
      userClassName,
    ]
      .filter((e) => e)
      .join(' ')}
    style={style}
    {...otherProps}
  >
    <h1 className="title span-grid remove-margin">
      {title}
    </h1>
    <p className="h2 subtitle span-grid remove-margin">
      <span className="x-highlighted c-x">
        {subtitle}
      </span>
    </p>
    <hr className="divider span-grid" />
    <div className="span-grid grid data">
      <div className="span-8 md-span-3">
        <p className="remove-margin">
          {initialProp}
        </p>
        <p className="remove-margin value">
          {initialValue}
        </p>
      </div>
      <div className="span-8 md-start-4 md-span-3">
        <p className="remove-margin">
          {secondaryProp}
        </p>
        <p className="remove-margin value">
          {secondaryValue}
        </p>
      </div>
      <div className="span-8 md-start-8 md-span-3">
        <p className="remove-margin">
          Share
        </p>
        <div className="social-media-share-buttons">
          <SocialMediaShareButton type="facebook" />
          <SocialMediaShareButton type="twitter" />
        </div>
      </div>
    </div>
    <img
      className="span-grid illustration"
      src={mainImage}
      alt={title}
    />
  </div>
)

CaseStudyHeading.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   *  The children JSX
   */
  children:PropTypes.node,

  /**
   * The name of the company for the case study
   */
  company:PropTypes.string.isRequired,

  /**
   * The industry of the company
   */
  industry:PropTypes.string.isRequired,

  /**
   * The title of the case study
   */
  title:PropTypes.string.isRequired,

  /**
   * The subtitle of the case study
   */
  subtitle:PropTypes.string,

  /**
   * The initial prop
   */
  initialProp:PropTypes.string,

  /**
   * The secondary prop
   */
  secondaryProp:PropTypes.string,

  /**
   * The initial value
   */
  initialValue:PropTypes.string.isRequired,

  /**
   * The secondary value
   * */
  secondaryValue:PropTypes.string.isRequired,

  /**
   * The main image
   */
  mainImage:PropTypes.string.isRequired,
}

CaseStudyHeading.defaultProps = {
  initialProp  :'Company',
  secondaryProp:'Industry',
}

export default CaseStudyHeading
